import { loadTeasersOnScroll } from './loadTeasers';
import { getIndex } from './helpers.js';

export function inViewport() {
  const animatedElements = document.querySelectorAll(
    '._js_inViewport, .__js_preload, .article__hero, .btn--load, .wideo__wrapper, .cooperation__text',
  );

  const obsCallback = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains('_js_inViewport')) {
          entry.target.classList.add('__js_onScreen');
        }
        if (entry.target.classList.contains('article__hero')) {
          entry.target.querySelector('img').classList.add('article__hero--visible');
        }
        if (entry.target.classList.contains('cooperation__text')) {
          document.querySelectorAll('.cooperation__text').forEach((el) => {
            el.classList.remove('cooperation__text--visible');
          });
          entry.target.classList.add('cooperation__text--visible');
        }
        if (entry.target.classList.contains('btn--load')) {
          loadTeasersOnScroll(entry.target);
        }
        if (entry.target.classList.contains('wideo__wrapper') && entry.target.querySelector('.lazy-loading')) {
          const lazyVideo = entry.target.querySelector('.lazy-loading');
          lazyVideo.autoplay = true;
          lazyVideo.muted = true;
          lazyVideo.play();
          lazyVideo.loop = true;
          lazyVideo.classList.remove('lazy-loading');
          observer.unobserve(lazyVideo);
        }
        if (entry.target.classList.contains('__js_preload')) {
          const srcS = entry.target.getAttribute('data-src');
          (entry.target).style.opacity = '0.3';
          entry.target.setAttribute('src', srcS);
          (entry.target).style.opacity = '1';
          entry.target.classList.remove('__js_preload');
          observer.unobserve(entry.target);
        }
      } else if (
        entry.target.classList.contains('_js_inViewport')
            && entry.target.classList.contains('__js_onScreen')
      ) {
        // entry.target.classList.remove('__js_onScreen');
        observer.unobserve(entry.target);
      } else if (entry.target.classList.contains('cooperation__text') && getIndex(entry.target) > 0) {
        if (entry.target.classList.contains('cooperation__text')) {
          document.querySelectorAll('.cooperation__text').forEach((el) => {
            el.classList.remove('cooperation__text--visible');
          });
          document.querySelectorAll('.cooperation__text')[getIndex(entry.target) - 1].classList.add('cooperation__text--visible');
        }
      }
    });
  };

  const observer = new IntersectionObserver(obsCallback, {
    root: null,
    threshold: 0,
    // rootMargin: '-10px',
  });

  animatedElements.forEach((elem) => {
    observer.observe(elem);
  });
}
